import { Factory } from '../../../lib/api';
const deletePolygons = (polygonIds) => Factory.delete('api/v2/polygons/delete', {}, { polygon_ids: polygonIds });
export default deletePolygons;
